import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-operator-layout',
  templateUrl: './login-operator-layout.component.html',
  styleUrls: ['./login-operator-layout.component.scss']
})
export class LoginOperatorLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
